@if (ide1 || ide2) {
  <div class="ide_container">
    <h2>currently coding on.</h2>
    @if (ide1) {
      <div class="ide_card">
        <img class="ide_img" src="https://{{ ide1.image }}"/>
        <div class="project_info">
          <strong>Projekt: {{ide1.project}}</strong>
          <span>State: {{ide1.state}}</span>
          <span id="counter_ide1">{{ide1.timestamp}}</span>
        </div>
      </div>
    }
    @if (ide2) {
      <div class="ide_card">
        <img class="ide_img" src="https://{{ ide2.image }}"/>
        <div class="project_info">
          <strong>Project: {{ide2.project}}</strong>
          <span>State: {{ide2.state}}</span>
          <span id="counter_ide2">{{ide2.timestamp}}</span>
        </div>
      </div>
    }
  </div>
}